import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';

export function PageFooterPagination({ page, totalPages, setPage }: { page: number; totalPages: number; setPage: (pg: number) => void }) {
  // Array of buttons what we see on the page
  const [arrOfCurrentPages, setArrOfCurrentPages] = useState<number[]>([]);

  // Set number of pages
  const numberOfPages: number[] = [];
  for (let i = 1; i <= totalPages; i++) {
    numberOfPages.push(i);
  }

  // For pagination
  useEffect(() => {
    let tempNumberOfPages = [...numberOfPages];

    if (page >= 1 && page < 3) {
      tempNumberOfPages = tempNumberOfPages.slice(0, 3);
    } else if (page >= 3 && page <= numberOfPages.length - 3) {
      tempNumberOfPages = [page - 1, page, page + 1];
    } else if (page >= numberOfPages.length - 3) {
      tempNumberOfPages = tempNumberOfPages.slice(numberOfPages.length - 3);
    }

    setArrOfCurrentPages(tempNumberOfPages);
  }, [page]);
  // Show buttons
  const renderPageNumbers = arrOfCurrentPages.map((pg: number, idx: number) => {
    if (pg) {
      return (
        <li
          key={idx}
          onClick={() => setPage(pg)}
          className={`h-10 w-10 rounded-full p-2 flex justify-center items-center cursor-pointer transition duration-400 ease-in-out ${
            page === pg
              ? 'bg-primaryColor-normal text-white hover:bg-primaryColor-medium'
              : 'bg-white text-neutralColor-dark hover:bg-primaryColor-medium hover:text-white'
          }`}
        >
          {pg}
        </li>
      );
    } else {
      return null;
    }
  });
  return (
    <div className='flex py-4 justify-center items-center rounded-lg '>
      <ul className='flex items-center gap-2'>
        <li
          onClick={() => setPage(page === 1 ? page : page - 1)}
          className={`flex justify-center item-center rounded-full p-2 bg-white text-neutralColor-light  cursor-pointer transition duration-400 ease-in-out ${
            page !== 1 && 'hover:text-white hover:bg-primaryColor-normal'
          }`}
        >
          <ChevronLeftIcon className='h-5 w-5' />
        </li>
        {/*<p*/}
        {/*    className="flex justify-center item-center rounded-full p-2  text-neutralColor-light  bg-primaryColor-normal cursor-pointer transition duration-400 ease-in-out"*/}
        {/*>*/}
        {renderPageNumbers}
        {/*</p>*/}
        <li
          onClick={() => setPage(page === numberOfPages.length ? page : page + 1)}
          className={`flex justify-center item-center rounded-full p-2 bg-white text-neutralColor-light cursor-pointer transition duration-400 ease-in-out ${
            page !== totalPages && 'hover:text-white hover:bg-primaryColor-normal'
          }`}
        >
          <ChevronRightIcon className='h-5 w-5' />
        </li>
      </ul>
    </div>
  );
}
